import React from 'react';
import { xcss, Box } from '@atlaskit/primitives';
import { useActiveRightSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { requestTypeTableSettingsPanelEntrypoint } from './entrypoint.tsx';

export const TABLE_SETTINGS_PANEL_ID = 'requestTypesTableFiltersRightPanel';

type Props = {
	projectKey: string;
};

export const TableSettingsPanel = ({ projectKey }: Props) => {
	const rightSidebarCurrentState = useActiveRightSidebarState();
	const cloudId = useCloudId();

	const { entryPointReferenceSubject, entryPointActions } = useEntryPoint(
		requestTypeTableSettingsPanelEntrypoint,
		{
			projectKey,
			cloudId,
		},
	);

	if (rightSidebarCurrentState?.panelId === TABLE_SETTINGS_PANEL_ID) {
		entryPointActions.load();

		return (
			<Box xcss={sidebarStyle}>
				<JiraEntryPointContainer
					id={TABLE_SETTINGS_PANEL_ID}
					packageName="jiraServicedeskRequestTypesTableViewSettings"
					teamName="jsm-getting-started"
					entryPointReferenceSubject={entryPointReferenceSubject}
					runtimeProps={{
						projectKey,
					}}
				/>
			</Box>
		);
	}
	return null;
};

const sidebarStyle = xcss({
	backgroundColor: 'elevation.surface.overlay',
	boxShadow: 'elevation.shadow.overlay',
	height: '100%',
	position: 'fixed',
});
